import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import styles from "./FeeRange.module.scss";
import fee from "../../assets/images/feerange.png";
import HtmlPopup from "../HtmlPopup";
import { useRouter } from "next/router";

const FeeRange = ({ data, ctaPopupData }) => {

  const router = useRouter();
  const { slug } = router?.query;

  const [displayPopup, setDisplayPopup] = useState(false);
  const title = ctaPopupData?.feeCta?.ctapopuptitle;
  const content = ctaPopupData?.feeCta?.ctapopup?.content?.[0]?.content?.[0]?.text

  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (slug !== "cranleigh-abu-dhabi"){
        clearInterval(interval);
      }
      const container = containerRef.current;
      if (!container) return;
      const buttonEl = container.querySelector("#cta-crangleigh-school-fee");
      if (buttonEl) {
        const handleClick = (e) => {
          e.preventDefault();
          openPopUp();   
        };
        buttonEl.addEventListener("click", handleClick);
        clearInterval(interval);
      }
    }, 100);
  
    return () => {
      clearInterval(interval);
      const container = containerRef.current;
      if (container) {
        const buttonEl = container.querySelector("#cta-crangleigh-school-fee");
        if (buttonEl) {
          buttonEl.removeEventListener("click", openPopUp);
        }
      }
    };
  }, [data]);
    
  const openPopUp = () => {
    setDisplayPopup(true);
  }

  // let t= '<div class="container FeeRange_overlay__PXoqt"> <div class="FeeRange_column__CWl2k"> <h2>Annual fee <u>AED</u></h2> <h3>69,670 to 103,260 AED</h3> <h4>FS1 to Year 13</h4><a href="#" id="cta-crangleigh-school-fee"  class="button FeeRange_anchors__wq_Fw"><span>KNOW MORE</span> <img alt="fee" loading="lazy" width="24" height="24" decoding="async" data-nimg="1" class="FeeRange_arrow__SQnEG" src="https://mms-delivery.sitecorecloud.io/api/media/v2/delivery/545ff802-4b88-4b4b-1933-08dc23ac2ebb/5b9690ab823a44fe9354fe19e3ae3841" style="color: transparent;"> </a> </div></div>'

  return (
    <>
      {data && (
        <div
          className="container sec_padding freerange-sec"
          data-testid="feerange-container-id"
        >
          <div className={styles.fee_range_main}>
            <div className={styles.image_container}>
              <Image src={fee} alt="fee" className={styles.bg_img} />
              <div className={styles.overlay}>
                <div
                  ref={containerRef}
                  className={styles.column}
                  dangerouslySetInnerHTML={{
                    __html: data?.description?.content?.[0]?.content?.[0]?.text,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {
        displayPopup 
        && ctaPopupData 
        && <HtmlPopup
          showPopup={displayPopup}
          setShowPopup={setDisplayPopup}
          title = {title}
          htmlContent={content}
        />
      }
    </>
  );
};

export default FeeRange;
